<template>
	<listagem-itens
		:itens="itens"
		:colunas="colunas"
		:paginacao="paginacao"
		:total-itens="totalItens"
		:total-paginas="totalPaginas"
		:tamanho-maximo-colunas="tamanhoMaximoColunas"
		:textos-do-template-da-listagem-vazia="textosDaListagemVazia"
		:custom-columns="colunasPersonalizadas"
		@paginar="emitirPaginar"
		@resetar-page="emitirResetarPage"
	>
		<template #cnpj="{ item }">
			<span>{{ formatarCnpj(item.cnpj) }}</span>
		</template>

		<template #codigoUnidadeCompradora="{ item }">
			<span>{{ formatarTextoVazio(item.codigoUnidadeCompradora) }}</span>
		</template>
	</listagem-itens>
</template>

<script>
import ListagemItens from '@/views/components/ListagemItens'
import tabelaMixin from '@/views/mixins/tabela'
import { TabelaColunaUtils } from '@/core/utils'

const TEXTO_VAZIO = '-'

export default {
	name: 'partes-envolvidas-listagem',
	components: { ListagemItens },
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	emits: ['paginar', 'resetar-page'],
	data() {
		return {
			colunasPersonalizadas: ['cnpj', 'codigoUnidadeCompradora'],
			textosDaListagemVazia: {
				titulo: 'A ata não possui partes envolvidas',
				mensagem: 'Clique no botão para adicionar uma parte envolvida.',
			},
			tamanhoMaximoColunas: {
				nomeOrgao: 60,
			},
		}
	},
	computed: {
		colunas() {
			return [
				new TabelaColunaUtils('Órgão', 'nomeOrgao', '50%'),
				new TabelaColunaUtils('CNPJ', 'cnpj', '25%'),
				new TabelaColunaUtils('Unidade Compradora', 'codigoUnidadeCompradora', '25%'),
			]
		},
	},
	methods: {
		formatarCnpj(cnpj) {
			if (!cnpj) return TEXTO_VAZIO
			return this.$options.filters.azCpfCnpj(cnpj)
		},
		formatarTextoVazio(valor) {
			return valor || TEXTO_VAZIO
		},
		emitirPaginar(paginacao) {
			this.$emit('paginar', paginacao)
		},
		emitirResetarPage() {
			this.$emit('resetar-page')
		},
	},
}
</script>
